import { ariaFlush, getLogger } from './AriaWrapper';
import { oneDSFlush } from './OneDsWrapper';

export function getOTelAddinsLogger(tenantToken: string) {
    return getLogger(tenantToken);
}

export function flush(): void {
    ariaFlush();
    oneDSFlush();
}

export { default as logSigsDatapoint } from './logSigsDatapoint';
export { default as getResourceTimingForUrl } from './utils/getResourceTimingForUrl';
export { initializeAnalytics } from './initializeAnalytics';
export { default as logDatapoint } from './logDatapoint';
export { logAddinsCustomerContent } from './logCustomerContent';
export { logPerformanceDatapoint } from './logPerformanceDatapoint';
export { logCLPAriaDataPoint } from './logCLPAriaDataPoint';
export { default as getActionableMessageLogger } from './utils/getActionableMessageLogger';
